export const MAGENTO_TOKEN_KEY = 'perpay.magento.token';
